import { Chip } from '@mui/material';
import { habuColors } from 'Theme';
import { styled } from '@mui/material/styles';


export const HStatusChip = styled(Chip)({
  background: habuColors.neutral[20],
  color: habuColors.secondary[80],
  borderColor: habuColors.neutral[20],
  flexShrink: 0,
  width: 25,
  height: 25,
});
